const carouselItems = [
  {
    tag: '热播推荐',
    title: '星河之约：年度都市情感大戏',
    desc: '当爱情遇到现实，谁能为爱坚守到底？全网同步更新，高清不缓冲追剧体验，每一集都让你沉浸其中。',
    img: 'https://readdy.ai/api/search-image?query=Romantic%20urban%20drama%20scene%20at%20golden%20hour%2C%20couple%20silhouette%20against%20city%20sunset%20skyline%2C%20warm%20amber%20lighting%2C%20cinematic%20composition%20with%20soft%20bokeh%2C%20emotional%20intimate%20atmosphere%2C%20film%20aesthetic%20with%20rich%20tones%2C%20tender%20romantic%20mood%2C%20professional%20photography&width=1200&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    tag: '动作巨制',
    title: '暗夜追击：年度悬疑动作大片',
    desc: '一场精心策划的阴谋，一次孤注一掷的追击。4K超清画质，紧张刺激的剧情让你肾上腺素飙升。',
    img: 'https://readdy.ai/api/search-image?query=Intense%20action%20thriller%20night%20scene%2C%20dramatic%20urban%20chase%20with%20deep%20shadows%20and%20warm%20street%20lights%2C%20cinematic%20wide%20angle%20composition%2C%20moody%20atmosphere%20with%20high%20contrast%2C%20film%20noir%20aesthetic%2C%20suspenseful%20energy%2C%20professional%20movie%20cinematography%2C%20dark%20rich%20tones&width=1200&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    tag: '古装经典',
    title: '长安旧事：全40集权谋史诗完结',
    desc: '朝堂之上的明争暗斗，江湖之中的恩怨情仇。一口气追完整部大戏，感受古装权谋的魅力。',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20palace%20scene%20with%20dramatic%20lighting%2C%20traditional%20architecture%20and%20flowing%20silk%20robes%2C%20warm%20lantern%20glow%20atmosphere%2C%20cinematic%20composition%20with%20rich%20golden%20amber%20tones%2C%20historical%20epic%20aesthetic%2C%20misty%20mountain%20backdrop%2C%20elegant%20period%20drama%20style&width=1200&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    tag: '综艺热播',
    title: '欢乐星期天：笑点密集的国民综艺',
    desc: '全新嘉宾阵容爆笑来袭，每一期都是快乐的源泉。轻松追综艺，让欢笑填满你的每个周末。',
    img: 'https://readdy.ai/api/search-image?query=Colorful%20variety%20show%20stage%20with%20dynamic%20warm%20spotlight%20effects%2C%20cheerful%20bright%20atmosphere%2C%20modern%20TV%20studio%20production%20design%2C%20vibrant%20entertainment%20energy%2C%20festive%20colorful%20lighting%2C%20professional%20broadcast%20aesthetic%2C%20lively%20celebration%20mood%2C%20rich%20warm%20tones&width=1200&height=600&seq=carousel-04&orientation=landscape',
  },
  {
    tag: '国漫崛起',
    title: '山海传说：第三季定档预告首发',
    desc: '古老神话的全新演绎，国漫顶级制作水准。山海之间的奇幻冒险，即将再度震撼归来。',
    img: 'https://readdy.ai/api/search-image?query=Fantasy%20animation%20style%20scene%20with%20mythical%20creatures%20and%20magical%20mountain%20landscape%2C%20warm%20ethereal%20glowing%20atmosphere%2C%20cinematic%20composition%20with%20soft%20dramatic%20lighting%2C%20ancient%20Chinese%20mythology%20aesthetic%2C%20epic%20scale%20with%20misty%20valleys%2C%20rich%20golden%20and%20coral%20tones%2C%20artistic%20illustration%20quality&width=1200&height=600&seq=carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">焦点推荐</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">编辑精选优质影视内容，总有一部适合你</p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {carouselItems.map((item, i) => (
            <div
              key={i}
              className={`group rounded-2xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                i < 2 ? 'lg:col-span-1' : ''
              } ${i === 0 ? 'md:col-span-2 lg:col-span-2' : ''}`}
            >
              <div className={`relative overflow-hidden ${i === 0 ? 'aspect-[2/1]' : 'aspect-video'}`}>
                <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent"></div>
                <div className="absolute top-4 left-4">
                  <span className="px-3 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium whitespace-nowrap">{item.tag}</span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-sm md:text-base font-bold text-background-50 mb-2">{item.title}</h3>
                  {i === 0 && <p className="text-xs text-background-50/80 leading-relaxed line-clamp-2">{item.desc}</p>}
                </div>
              </div>
              {i !== 0 && (
                <div className="p-5">
                  <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}